import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';

export const azureAdAuthGuard: CanActivateFn = (route, state) => {
  const calService = inject(CalAngularService);
  const router = inject(Router);

  return calService.isUserSignedIn().pipe(
    take(1),
    switchMap(isSignedIn => {
      if (!isSignedIn) {
        // Save the intended destination before redirecting
        sessionStorage.setItem('redirectUrl', state.url);
        // Trigger sign-in (this will cause a full page redirect to Azure AD)
        calService.userInitiatedSignIn().subscribe();
        // Navigate to landing page instead of allowing the route to load
        router.navigate(['/']);
        return of(false);
      }

      // Mark the identity provider so the HTTP interceptor uses the Azure AD branch.
      localStorage.setItem('bq-idp', 'azure-ad');

      // Pre-warm the API access token before activating SDD/CDD so the first
      // API call has a valid token (with app roles). Without this, opening the
      // module directly races MSAL token acquisition and the backend returns 403.
      return calService.getAADToken([environment.apiUrl]).pipe(
        take(1),
        map(() => true),
        // Even if pre-warming fails, allow navigation; the interceptor will
        // handle any 403 and redirect to request-access as before.
        catchError(() => of(true))
      );
    })
  );
};
